import React, { useEffect } from "react";

import { Divider } from "antd";

import ModalView from "../../../core/components/modal";
import { Spin, Row } from "antd";

import Details from "../show/details";
import TaskList from "../task/list/full";
import { useDispatch, useSelector } from "react-redux";

import { load, reset } from "../../../redux/actions/job/show";

const ModalJob = (props) => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.job.show);

    useEffect(() => {
        if (props.id) {
            const job = dispatch(load(props.id));
        }

        return () => {
            dispatch(reset());
        };
    }, [props.id]);
    return (
        <ModalView
            onCancel={props.onCancel}
            title={data?.job ? data.job.name : ""}
            visible={props.visible}
            render={() => {
                if (loading || data === null) {
                    return (
                        <Row justify="center">
                            <Spin />{" "}
                        </Row>
                    );
                }
                return (
                    <>
                        <Details forVendor={props.forVendor} job={data.job} allowEdit={false} />
                        <Divider plain />
                        <TaskList forVendor={props.forVendor} job={data.job} />
                    </>
                );
            }}
        />
    );
};

export default ModalJob;
